import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, userPreferenceDetailFeatureKey } from './user-preference-detail.reducer';

export const getUserPreferenceDetailFeature = createFeatureSelector<State>(userPreferenceDetailFeatureKey);

export const getCallState = createSelector(getUserPreferenceDetailFeature, (state) => {
   return state?.callState;
});

export const getUser = createSelector(getUserPreferenceDetailFeature, (state) => {
   return state.user;
});
